/*
 * @Author: JamesWong
 * @Description: 支付配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-04-08 14:13:44
 */
export default {
  channelPaymentMethods: '渠道支付方式',
  set: '设置',
  setPaymentMethods: '设置支付方式',
  confirm: '确定',
  cancel: '取消',
  channel: '渠道',
  order: '序号',
  channelNumber: '渠道编号',
  account: '户口',
  accountFilter: '户口筛选',
  weChatScanPayment: '微信扫码付',
  paymentSetTips: '提示：同时编辑多个渠道时，支付方式需要重新选择，不选择将被置为空',
  pleaseSelectAgain: '请重新选择',
  selectPaymentMethod: '选择支付方式',
  paymentNumber: '支付编号',
  merchantID: '商户ID',
  submerchantID: '子商户ID',
  Note: '备注',
  appId: '商户ID',
  token: '授权Token',
  tokenTime: '授权时间',
  wechatFaceIDPay: '微信刷脸支付',
  wechatClientSelfpay: '微信客户自付',
  alipayScancodePay: '支付宝扫码付',
  alipayNumber: '支付宝编号',
  systemBusinessNumber: '系统商编号',
  enterChannelTips: '请输入渠道编号、名称搜索',
  channelName: '渠道名称',
  wechatPaymentDisposition: '微信支付配置',
  wechatPaymentTips: '微信支付支持三种支付类型：',
  wechatPaymentTips1: '1.扫码支付：收银员扫客户的付款码，适用于POS收银；',
  wechatPaymentTips2: '2.刷脸支付：客户在特定自助机器上，自主完成刷脸支付，适用于自主购物机；',
  wechatPaymentTips3: '3.客户自支付：客户在个人手机中点击付款，调用微信支付，适用于微商城、扫码购程序；',
  wechatPaymentTipsPlus: '注意：三种类型只能各自默认一个支付，渠道没有单独配置支付方式时，将自动使用默认的支付方式。',
  Mode: '模式',
  type: '类型',
  defaultTips: '是否默认',
  default: '默认',
  operate: '操作',
  detail: '详情',
  paymentMethodDetail: '支付方式详情',
  paymentType: '支付类型',
  APPKEY: 'APPKEY',
  certification: '证书',
  certificationDocument: '证书文件',
  certificationPassword: '证书密码',
  alipayPaymentDisposition: '支付宝支付配置',
  status: '状态',
  authorizedMerchantID: '授权商户ID',
  authorized: '已授权',
  authorize: '授权',
  unAuthorized: '未授权',
  privateKey: '私钥',
  publicKey: '公钥',
  signatureType: '签名类型',
  selectedTips: '请先选择渠道再设置支付方式',
  success: '成功',
  configuredChannel: '已配置渠道',
  reauthorize: '重新授权'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/payment.js